<div class="notifications relative inline-flex items-center">
  <button
    type="button"
    class="notifications__trigger relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-none bg-transparent p-0 cursor-pointer text-[var(--p-text-color)] hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--p-primary-color)]"
    (click)="togglePanel($event)"
    [attr.aria-label]="
      'Notifications' + (pendingCountForAria() > 0 ? ', ' + pendingCountForAria() + ' pending' : '')
    "
  >
    <i class="pi pi-bell text-xl leading-none [font-weight:300]"></i>
    @if (badgeText()) {
      <span
        class="notifications__badge absolute -top-0.5 -right-0.5 flex min-h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded px-1 text-[0.65rem] font-semibold leading-none text-slate-900"
        aria-hidden="true"
        >{{ badgeText() }}</span
      >
    }
  </button>

  <p-overlayPanel
    #taskPanel
    [style]="{ width: 'min(26rem, calc(100vw - 2rem))' }"
    [dismissable]="true"
    appendTo="body"
    styleClass="notifications-overlay"
  >
    <div class="notifications-panel flex max-h-[min(28rem,80vh)] flex-col rounded-lg border border-slate-200 bg-white text-slate-900 shadow-sm">
      <div
        class="flex items-center justify-between gap-2 border-b border-slate-200 px-4 py-3"
      >
        <span class="text-base font-semibold">Notifications</span>
        @if (pendingHeaderLabel()) {
          <span
            class="notifications__pill-pending shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold"
            >{{ pendingHeaderLabel() }}</span
          >
        }
      </div>

      <div class="min-h-0 flex-1 overflow-y-auto px-0 py-2" (scroll)="onListScroll($event)">
        @if (loading()) {
          <div class="px-4 py-6 text-center text-sm text-slate-500">Loading&hellip;</div>
        } @else if (notifications().length === 0) {
          <div class="px-4 py-6 text-center text-sm text-slate-500">No notifications found.</div>
        } @else {
          <ul class="m-0 list-none p-0">
            @for (n of sortedNotificationsForDisplay(); track n.notificationID) {
              <li class="border-b border-slate-100 last:border-b-0">
                <div
                  class="notifications__row flex gap-3 px-4 py-3 cursor-pointer"
                  [class.notifications__row--unread]="!n.isRead"
                  [class.bg-blue-50]="!n.isRead"
                  [class.hover:bg-blue-100]="!n.isRead"
                  [class.hover:bg-slate-50]="n.isRead"
                  (click)="onRowClick(n, $event)"
                >
                  <div class="flex shrink-0 items-start self-start pt-0.5">
                    <div class="notifications__avatar-wrap shrink-0">
                      <app-user-avatar
                        [userId]="n.avatarUserID"
                        [displayName]="displayNameForAvatar(n)"
                        [skipBrandedSystemAvatar]="true"
                        size="1.5rem"
                      />
                      @if (!n.isRead) {
                        <span class="notifications__unread-indicator" aria-hidden="true"></span>
                      }
                    </div>
                  </div>
                  <div class="min-w-0 flex-1">
                    <div class="flex min-w-0 items-start gap-2">
                      <span class="min-w-0 flex-1 truncate font-semibold text-slate-900" [attr.title]="n.title">{{ n.title }}</span>
                      @if (isDueToday(n.createdOn)) {
                        <span
                          class="notifications__pill-due shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold"
                          >Due today</span
                        >
                      }
                    </div>
                    <div class="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-slate-500">
                      <i class="pi pi-calendar text-[0.7rem]"></i>
                      <span>{{ n.createdOn | date: 'dd/MM/yyyy' }}</span>
                      <span aria-hidden="true">&middot;</span>
                      @if (isCurrentUser(n.avatarUserID)) {
                        <span>You</span>
                      } @else {
                        <span class="truncate">{{ n.avatarDisplayName || n.title }}</span>
                      }
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
        }
        @if (!loading() && loadingMore()) {
          <div class="px-4 py-3 text-center text-sm text-slate-500">Loading more&hellip;</div>
        }
      </div>
    </div>
  </p-overlayPanel>
</div>
